import styles from './index.module.sass';
import { Button, Card } from '@autopass-web/mochi-component';
import { barcodeScanReceipt, getReceiptData } from './barcode-payment';
import { analytics } from '../../app-loader';
import useAppStore from '../../app-store';

const ReceiptCard = () => {
  const appStore = useAppStore();
  const receiptData = getReceiptData();

  if (barcodeScanReceipt.indexOf(receiptData.type) !== -1) return <></>;

  return (
    <Card className={styles['receipt-card']}>
      <div className={styles.title}>
        {receiptData.name}
        <Button
          type="text"
          onClick={() => {
            analytics.barcode_payment_receipt_onClick();
            appStore.globalAction.setRedirectLink('/barcode-payment');
            appStore.globalAction.push('/receipt-setting');
          }}
          style={{ fontSize: 13 }}
        >
          更改
        </Button>
      </div>
      <div className={styles.content}>{receiptData.value}</div>
    </Card>
  );
};

export default ReceiptCard;
